import {useTranslation} from 'react-i18next';

import {Grid, Typography} from '@mui/material';

import {TotalCountPerStatusObject} from '../types/RecruitingDashboardTypes';

import {ApplicantsCounter} from './ApplicantsCounter';
import {EmpionPaper} from '../../../../../components/EmpionPaper/EmpionPaper';
import {MatchStatus} from '../../../../../types/MatchStatus/MatchStatus';
import {getMatchStatusColor} from '../../../../../utils/matchUtils';

interface Props {
  matchesTotalCount?: TotalCountPerStatusObject;
}

export default function DashboardHeader({matchesTotalCount}: Props) {
  const {t} = useTranslation();
  const td = (key: string) => t(`companyRecruitingDashboard.header.${key}`);

  const paperStyles = {
    minHeight: '150px',
    mt: 4,
    padding: '16px',
  };

  const totalCountStatuses = [
    {
      status: td('statuses.new'),
      count: matchesTotalCount?.totalCountPerStatus.accepted || 0,
      borderColour: getMatchStatusColor(MatchStatus.Accepted),
    },
    {
      status: td('statuses.contacted'),
      count: matchesTotalCount?.totalCountPerStatus.contacted || 0,
      borderColour: getMatchStatusColor(MatchStatus.Contacted),
    },
    {
      status: td('statuses.interview'),
      count: matchesTotalCount?.totalCountPerStatus.interview || 0,
      borderColour: getMatchStatusColor(MatchStatus.Interview),
    },
    {
      status: td('statuses.hired'),
      count: matchesTotalCount?.totalCountPerStatus.hired || 0,
      borderColour: getMatchStatusColor(MatchStatus.Hired),
    },
  ];

  return (
    <EmpionPaper sx={paperStyles}>
      <Grid container>
        <Grid item xs={12}>
          <Typography variant='h2' my={2}>
            {td('title')}
          </Typography>
        </Grid>
        {totalCountStatuses.map((item, index) => (
          <Grid item xs={6} md={3} key={index}>
            <ApplicantsCounter status={item.status} count={item.count} borderColour={item.borderColour} />
          </Grid>
        ))}
      </Grid>
    </EmpionPaper>
  );
}
